import React from 'react';
import AppLayout from 'components/Layout/AppLayout';
import { QueryClientProvider } from '@tanstack/react-query';
import UserProvider from 'context/UserProvider';
import { useBetterAuth } from 'context/BetterAuthProvider';
import { useBetterAuthUserStore } from 'store/betterAuthUserStore';
import AuthenticatedRoutes from 'routes/AuthenticatedRoutes';
import queryClient from 'helpers/queryClient';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import BetterAuthProtectedRoute from 'components/ProtectedRoute/BetterAuthProtectedRoute';
import { Permission } from 'api/user';
import { can } from 'helpers/userUtils';
import { useMe } from 'store/userStore';
import { AiCoachAssistant } from 'components/AiCoachAssistant/AiCoachAssistant';
import { ChatClientProvider } from 'context/ChatClientProvider';

const AuthenticatedApp = () => {
  const { user } = useBetterAuth();
  const me = useMe();
  const fetchUserData = useBetterAuthUserStore((state) => state.fetchUserData);

  React.useEffect(() => {
    if (user) {
      const betterAuthUser = {
        id: user.id,
        email: user.email,
        name: user.name,
        emailVerified: user.emailVerified,
      };
      fetchUserData(betterAuthUser);
    }
  }, [fetchUserData, user]);

  return (
    <BetterAuthProtectedRoute>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />

        <ChatClientProvider>
          <UserProvider>
            <AppLayout>
              <AuthenticatedRoutes />
            </AppLayout>
          </UserProvider>

          {can(me, Permission.AI_ASSISTANT_USE) && <AiCoachAssistant />}
        </ChatClientProvider>
      </QueryClientProvider>
    </BetterAuthProtectedRoute>
  );
};

export default AuthenticatedApp;
